import { z } from "zod";

import { modulatorDtoSchema } from "../modulator/modulator-dto";

export const autoDiagModulatorDtoSchema = modulatorDtoSchema.extend({
  measuredPower: z.number().nullable(),
});

export type TAutoDiagModulatorDto = z.infer<typeof autoDiagModulatorDtoSchema>;
